import CommunityContactInformation from '@/components/CommunityContactInformation/CommunityContactInformation';
import Hero from '@/components/Hero/Hero';
import ScheduleTourCard from '@/components/ScheduleTourCard/ScheduleTourCard';
import { useAppContext } from '@/contexts/AppContext';
import { useUnit } from '@/hooks/units';
import { getRouteApi } from '@tanstack/react-router';
import type { FC } from 'react';

const route = getRouteApi('/_layout/contact');

const ContactPage: FC = () => {
  const { community } = useAppContext();
  const { unitId } = route.useSearch();
  const { data: unit } = useUnit.useQuery([community.id, unitId]);

  if (!unit) {
    return null;
  }

  return (
    <div>
      <Hero
        title="Schedule Your Tour"
        subtitle="Visit our community and discover your future home"
        showCTA={false}
      />
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:grid lg:grid-cols-2 gap-12 items-start">
            <div className="lg:sticky top-24 order-1 lg:order-2">
              <ScheduleTourCard unit={unit} />
            </div>
            <CommunityContactInformation
              unitId={unitId}
              title="Get in Touch"
              detail="We'd love to show you around our community! Fill out the form to schedule a tour or
        contact us directly using the information below."
              className="order-2 lg:order-1"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
